export class FiltroSoggettoAnagrafeVO {
  nome: string;
  cognome: string;
  codice: string = "";
  cfImpresa: string = "";
  denominazione: string;
  nazione: string;
  tipoSoggetto: string = ""; // TipoSoggettoAnagrafeEnum;
}
